export default defineNuxtRouteMiddleware(async (to, from) => {
	const pageStore = usePageStore();
	const userStore = useUserStore();
	const sessionManager = useSessionManager();
	const authCookie = useCookie<string | null>("accessToken");
	const userCookie = useCookie<string | null>("user", {
		maxAge: 60 * 60 * 24 * 7
	});

	if (from.name?.toString()) {
		pageStore.setPreviousPage(from.name.toString());
	}
	pageStore.setCurrentPage(to.name?.toString() ?? "");

	const isLoginPage = to.path === "/login" || pageStore.currentPage === "Login";
	const hasToken = Boolean(authCookie.value);

	sessionManager.syncSessionFromToken(authCookie.value);

	if (hasToken) {
		userCookie.value = userStore.userID ? String(userStore.userID) : null;
	}

	if (!hasToken && !isLoginPage) {
		// O `return` aqui não é cosmético. Dentro de um middleware o `navigateTo`
		// disparado por `logout()` apenas DEVOLVE o destino — quem redireciona é o
		// Nuxt, ao receber esse destino como retorno do middleware. Antes o retorno
		// era descartado e a navegação original seguia: sem token o usuário caía na
		// `index.vue`, que chama `setPageLayout("collector")`. Como isso acontece
		// durante a hidratação, o Nuxt registra um `beforeResolve` que carimba
		// `layout = "collector"` na PRÓXIMA rota resolvida — a de login. Era daí que
		// vinha o topbar do coletor aparecendo por cima da tela de login.
		return await sessionManager.logout("missing-token");
	}
});
